import { Component, computed, EventEmitter, inject, Input, Optional, Output } from '@angular/core';
import { AutocompleteComponent } from "@shared/controls/autocomplete/autocomplete.component";
import { LinkComponent } from "@shared/components/commons/link/link.component";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { NgControl, ReactiveFormsModule } from "@angular/forms";
import { ValidationErrorComponent } from "@shared/controls/validation-error/validation-error.component";
import { CountriesService, ICountryOption } from "../../services/countries.service";
import { SelectOption } from "@models/ui-models/select-options";
import { FormSwitchButtonComponent } from "@shared/controls/form-switch-button/form-switch-button.component";

@Component({
  selector: 'app-flags-autocomplete',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    ReactiveFormsModule,
    ValidationErrorComponent,
    FormSwitchButtonComponent
  ],
  templateUrl: 'flags-autocomplete.component.html',
  styleUrls: ['../autocomplete/autocomplete.component.scss', 'flags-autocomplete.component.scss']
})
export class FlagsAutocompleteComponent extends AutocompleteComponent {
  private countryService = inject(CountriesService);

  @Input() override valuePrimitive = true;
  @Input() isDisabled = false;
  @Input() switchBtnText = '';
  @Input() readonly = false;
  @Input('options') override set optionsSetter(options: ICountryOption[]) {
    this.options = options;
  }

  @Output() switchBtnClick = new EventEmitter<boolean>();

  override options: ICountryOption[] = this.countryService.getCountriesWithFlags();
  #value: ICountryOption | null = null;
  override get value(): ICountryOption | null {
    return this.#value;
  }

  override set value(value: ICountryOption | null) {
    if (!value && this.searchControl.value) {
      const inputValue = this.searchControl.value;
      this.#value = this.options.find((option) => option.value === inputValue) ?? null;
      this.onChange(this.#value?.value);
    } else {
      this.#value = value;
      this.onChange(this.#value?.value);
    }
  }

  override filteredOptionsSignal = computed(() => {
    const searchControlValue = this.searchControlValueSignal();
    if (!searchControlValue)
      return this.options;

    const searchValue = (searchControlValue ?? '')?.toLowerCase();
    return this.options
      .filter((option) =>
        option.label
        && (option.label?.toLowerCase().includes(searchValue)
          || option.countryCode?.toLowerCase() == searchValue));
  });

  constructor(@Optional() protected override ngControl: NgControl) {
    super(ngControl);
  }

  override writeValue(value: SelectOption) {
    const valueString = (value as unknown as string)?.toString()?.toLowerCase();
    this.value = this.options.find((option) => (option.value as string)?.toString()?.toLowerCase() === valueString) ?? null;
  }

  override handleSearchControlChanges(value: string | null): void {
    this.searchControlValueSignal.set(value ?? '');
    if (!value) return;

    this.value = this.options.find((option) => (option.value as string)?.toString()?.toLowerCase() === value) ?? null;
  }

  override onDropdownChange(opened: boolean, searchInput: HTMLElement): void {
    this.searchControlValueSignal.set('');

    if (opened) {
      setTimeout(() => searchInput.focus());
    }
  }

  onClickBtn(): void {
    this.switchBtnClick.emit(true);
  }
}
